export class ShareLinkInvitationService {
    constructor(API_URLS) {
        this.API_URLS = API_URLS;
    }

    getShareableLink() {
        return this.getEndPoint().then((response) => response.json());
    }

    getEndPoint() {
        return Hop.get(this.API_URLS.shareableLink);
    }
}
